<template>
  <div class="reset-step-one">
    <div class="initial-form" v-if="!showResetForm">
      <div class="sub-header-login">
        <p>Please enter your verified username</p>
      </div>
      <ValidationObserver
        id="stepOne"
        ref="observerStepOne"
        autocomplete="off"
        tag="form"
        role="form"
        @submit.prevent="submitForm"
      >
        <ValidationProvider
          class="input-wrapper"
          v-slot="{ errors }"
          name="username"
          rules="required"
        >
          <v-text-field
            v-model="userName"
            height="45px"
            ref="username"
            label="User Name"
            name="username"
            required
            outlined
            prepend-inner-icon="mdi-account"
          />
          <span class="error-message">{{ errors[0] }}</span>
        </ValidationProvider>
        <div class="form-group text-center m-t-20">
          <div class="container-login100-form-btn">
            <v-btn
              height="42px"
              width="100%"
              padding="0 10px"
              color="primary"
              rounded
              type="submit"
              :loading="loading"
              :disabled="loading"
            >
              Submit
              <v-icon right dark>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <div class="forgot-pwd">
              <a @click.prevent="login">Login</a>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <verifyOtp @resetPassword="resetPassword" ref="verifyOtp" v-else />
  </div>
</template>
<script>
import Promise from "../../../../../lib/mixins/ExtendedPromises";
import Password from "../../../../../repositories/forgetPasswordController";
import verifyOtp from "./VerifyOtp";
export default {
  name: "StepOne",
  mixins: [Promise],
  components: {
    verifyOtp
  },
  data() {
    return {
      userName: "",
      loading: false,
      showResetForm: false,
      uniqueId: ""
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    async submitForm() {
      const valid = await this.$refs.observerStepOne.validate();
      if (valid) {
        this.loading = true;
        const operation = this.response(
          Password.forgotPassword({ userName: this.userName })
        );
        operation
          .then(data => {
            if (operation.isFulfilled()) {
              console.log(data);
              this.uniqueId = data.data.code;
              this.$toasted.show("OTP Sent Sucessfully", {
                type: "success"
              });
              this.loading = false;
              this.showResetForm = true;
              // this.$router.push({name: 'verifyOtp'})
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toasted.show(err.data.message, {
              type: "error"
            });
            
          });
      }
    },
    resetPassword(values) {
        console.log(values)
        values.userData.uniqueId = this.uniqueId;
      const operation = this.response(
          Password.setNewPassword(values.otp,values.userData)
        );
        operation
          .then(data => {
            if (operation.isFulfilled()) {
              console.log(data);
              this.uniqueId = data.data.code;
              this.$toasted.show("Password Reset Sucessful", {
                type: "success"
              });
              this.loading = false;
              this.showResetForm = true;
              this.$router.push('/login')
            }
          })
          .catch(err => {
            this.loading = false;
            this.$toasted.show(err.data.message, {
              type: "error"
            });
            this.$refs.verifyOtp.resetLoading();
          });
    }
  }
};
</script>
